/**
 * English / Deutsch / 中文 — the one language choice for the whole app. Each
 * name is written in its own language so it can be found from any of them.
 * Used by Settings › Preferences.
 */
import { ChipGroup } from "@/components/ui";
import { useT, type AppLanguage } from "@/i18n";
import { commonMessages } from "@/i18n/messages/common";
import {
  useAppLanguageStore,
  useEffectiveAppLanguage,
} from "@/stores/app-language-store";

/** Each language's own name, the same in every UI language. */
const LANGUAGE_OPTIONS: ReadonlyArray<{
  value: AppLanguage;
  label: string;
  testId: string;
}> = [
  { value: "en", label: "English", testId: "app-language-option-en" },
  { value: "de", label: "Deutsch", testId: "app-language-option-de" },
  { value: "zh", label: "中文", testId: "app-language-option-zh" },
];

export function AppLanguagePicker() {
  const t = useT(commonMessages);
  const language = useEffectiveAppLanguage();
  const setLanguage = useAppLanguageStore((state) => state.setLanguage);
  return (
    <ChipGroup
      value={language}
      onChange={setLanguage}
      options={LANGUAGE_OPTIONS}
      variant="segmented"
      ariaLabel={t("language")}
    />
  );
}
